import {
  React,
  useRef, 
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider, 
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

const MotorStatusDisplay = (props) => {

	const {
		azimuth_speed,
    azimuth_direction,
    zenith_speed,
    zenith_direction
  } = props;

	const labelStyle = {
		fontFamily:"sans-serif",
		fontWeight:"lighter"
	}

	const valueStyle = {
		marginTop:"3px",
		border:"1px solid grey",
		backgroundColor:"#dddddd",
		textAlign:"center",
		fontFamily:"sans-serif", fontWeight:"lighter"
	}


	return (
		<Grid
	    	style={{border:"1px solid #cccccc", padding:"2px", margin:"1px", height:"269px"}}
        	container
        	spacing={1}
    	>
	    	<Grid 
	         	item
	     		lg={12}
	            md={12}
	            xl={12}
	            xs={12}
	        >
	            <InputLabel shrink>Motor Status</InputLabel>
	        </Grid>
	        <Grid
	            item
	            xl={6}
	            lg={6}
	            md={6}
	            xs={6}
	        >
	        	<h1 style={labelStyle}>Azimuth:</h1>
	 		</Grid>
	 		<Grid
	            item
	            xl={6}
	            lg={6}
	            md={6}
	            xs={6}
	        >
	        	<h1 style={valueStyle}>{azimuth_speed}Hz</h1>
	            <h1 style={valueStyle}>{azimuth_direction}</h1>
	        </Grid>
	        <Grid
	            item
	            xl={6}
	            lg={6}
	            md={6}
	            xs={6}
	        >
	        	<h1 style={labelStyle}>Zenith:</h1>
	        </Grid>
	        <Grid
	            item
	            xl={6}
	            lg={6}
	            md={6}
	            xs={6}
	        >
	        	<h1 style={valueStyle}>{zenith_speed}Hz</h1>
	            <h1 style={valueStyle}>{zenith_direction}</h1>
	        </Grid>
        </Grid>
	);
}


MotorStatusDisplay.propTypes = {
};

export default MotorStatusDisplay;